(function () {
    "use strict";

    angular
        .module("app")
        .component("productDetail", { // product-detail
            templateUrl: "src/app/productDetail/productDetail.html",
            controller: controller
        });

    function controller($routeParams, $location, $uibModal, $analytics, toast, session, $timeout, CART_TYPE_CODE) {
        const $ctrl = this;
        const itemId = $routeParams.id;
        $ctrl.session = session;
        $ctrl.CART_TYPE_CODE = CART_TYPE_CODE;
        $ctrl.product = null;
        $ctrl.quantity = "";
        $ctrl.loading = true;
        $ctrl.busy = false;
        $ctrl.existingCount = 0;
        $ctrl.mnRequired = false;
        $ctrl.mnChecked = false;
        $ctrl.maxQuantity = 9999;
        $ctrl.kitCheck = false;

        $ctrl.selectedUom = null;
        $ctrl.selectedUomDesc = null;

        $ctrl.$onInit = () => {
            session.products
                .get(itemId)
                .then(loadProduct)
                .catch(toast.errorHandler)
                .finally(() => $ctrl.loading = false);
        };

        $ctrl.showIncentiveDetails = showIncentiveDetails;

        function showIncentiveDetails() {
            let modalInstance = $uibModal.open({
                template: `<incentive-details-modal on-dismiss="$ctrl.dismiss()" on-close="$ctrl.close(result)" incentive="$ctrl.incentive"></incentive-details-modal>`,
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    const ctrl = this;
                    ctrl.incentive = session.incentives.find(i => i.incentive_id === $ctrl.product.incentives[0].incentive_id);
                    ctrl.dismiss = $uibModalInstance.dismiss;
                    ctrl.close = result => $uibModalInstance.close(result);
                }],
                controllerAs: "$ctrl"
            });

            modalInstance.result
                .then(function (result) {
                    //console.log("modalInstance.result", result);
                });
        }

        $ctrl.selectUom = (uom, uomDesc) => {
            $ctrl.selectedUom = uom;
            $ctrl.selectedUomDesc = uomDesc;
        };

        $ctrl.canSelectUom = uom => {
            const inCart = session.cart.items.find(i => i.item_id === $ctrl.product.item_id);
            if (!inCart)
                return true;
            return inCart.sale_UOM === uom;
        };

        function loadProduct(product) {
            $ctrl.product = product;
            $ctrl.kitCheck = product.kit_check_selected;

            const sessionProduct = session.allProducts.find(p => p.item_id === product.item_id);
            if (sessionProduct)
                $ctrl.product.incentives = sessionProduct.incentives;

            $ctrl.mnRequired = product.confirm_to_sell === "Y";

            if (!product.max_sale_qty && product.max_sale_qty !== 0) {
                // null|undefined
            } else {
                $ctrl.maxQuantity = product.max_sale_qty; // Can be zero (not allowed to sell, but show in the cart)
            }

            $timeout(() => {
                    new Drift(document.querySelector('.product-detail-image'),
                        {
                            paneContainer: document.querySelector('.product-detail-image-zoom'),
                            hoverDelay: 500,
                            zoomFactor: 5,
                            hoverBoundingBox: false // this has a bug :(
                        });
                },
                100);

            const cartTypeCode = product.is_schedule_drug ? CART_TYPE_CODE.CSOS : CART_TYPE_CODE.RX;

            return session
                .setCartType(cartTypeCode)
                .then(() => {
                    const inCart = session.cart.items.find(i => i.item_id === product.item_id);
                    if (inCart) {
                        $ctrl.existingCount = inCart.quantity;
                        $ctrl.kitCheck = inCart.kit_check_surcharge != null;
                        $ctrl.selectUom(inCart.sale_UOM, inCart.sale_UOM_desc);
                    } else {
                        $ctrl.selectUom(product.sale_UOM, product.sale_UOM_desc);
                    }
                });
        }


        $ctrl.canAddToCart = () => {

            if ($ctrl.maxQuantity === 0)
                return false;

            let valid = $ctrl.quantity > 0
                && !$ctrl.isQuantityGreaterThanMaxQuantity()
                && !session.cart.isCartFull;

            if (valid && $ctrl.mnRequired)
                valid = $ctrl.mnChecked;

            return valid;
        };

        $ctrl.addToCartClicked = () => {
            $ctrl.busy = true;
            $analytics.eventTrack("Add to Cart", { category: "Product", label: `${$ctrl.product.full_description}`, value: `${itemId}` });
            const item = {
                item_id: itemId,
                quantity: $ctrl.quantity,
                quantity_uom_code: $ctrl.selectedUom,
                kit_check_surcharge: $ctrl.kitCheck ? $ctrl.product.kit_check_surcharge : null
            };
            session.cart
                .addItem(item)
                .then(() => $location.path("/cart"))
                .catch(toast.errorHandler)
                .finally(() => $ctrl.busy = false);
        };

        $ctrl.calcPrimaryPackQty = () => {
            const multiplier = $ctrl.selectedUomDesc === $ctrl.product.retail_packaging ? 1 : $ctrl.product.units_per_case;
            return $ctrl.product.vials_per_unit * multiplier * ($ctrl.quantity || 0);
        };

        $ctrl.isQuantityGreaterThanMaxQuantity = () => {
            if ($ctrl.existingCount) {
                return $ctrl.quantity + $ctrl.existingCount > $ctrl.maxQuantity;
            }
            return $ctrl.quantity > $ctrl.maxQuantity;
        };

        $ctrl.getMaxQuantityErrorMessage = () => {
            return `This product will be allocated to a maximum of ${$ctrl.maxQuantity} ${$ctrl.selectedUomDesc}${$ctrl.maxQuantity === 1 ? "" : "s"} per purchase order.`;
        }

        $ctrl.shouldContactCustomerService = () => {
            const ndcs = ['69374-520-05'];
            return ndcs.indexOf($ctrl.product.ndc_code) >= 0;
        }
    }
    controller.$inject = ["$routeParams", "$location", "$uibModal", "$analytics", "stToastFactory", "sessionService", "$timeout", "CART_TYPE_CODE"];

})()